export const formInputSizes = {
	default: 'default',
	small: 'small',
} as const;

export type FormInputSize = typeof formInputSizes[keyof typeof formInputSizes];
